// interface Date {
//   addSeconds(seconds: number): Date;
//   addMinutes(minutes: number): Date;
//   addHours(hours: number): Date;
//   addDays(days: number): Date;
//   toFormatString(format?: string): string;
//   isGreaterThan(target: Date): boolean;
//   isGreateEqual(target: Date): boolean;
//   isLessThan(target: Date): boolean;
//   isLessEqual(target: Date): boolean;
// }

Date.prototype.addSeconds = function (seconds) {
  let rtn = new Date();
  let timestamp = this.getTime();
  timestamp += 1000 * seconds;
  rtn.setTime(timestamp);
  return rtn;
}

Date.prototype.addMinutes = function (minutes) {
  return this.addSeconds(60 * minutes);
}

Date.prototype.addHours = function (hours) {
  return this.addMinutes(60 * hours);
}

Date.prototype.addDays = function (days) {
  return this.addHours(24 * days);
}

Date.prototype.toFormatString = function (format) {
  format = format || "yyyy-MM-dd hh:mm:ss";
  let o = {
      "M+": this.getMonth() + 1,                 //月份   
      "d+": this.getDate(),                    //日   
      "h+": this.getHours(),                   //小时   
      "m+": this.getMinutes(),                 //分   
      "s+": this.getSeconds(),                 //秒   
      "q+": Math.floor((this.getMonth() + 3) / 3), //季度   
      "S": this.getMilliseconds()             //毫秒   
  }
  if (/(y+)/.test(format)) {
      format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (let k in o) {
      if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
      }
  }

  return format
}

Date.prototype.isGreaterThan = function (target) {
  return this > target;
}
Date.prototype.isGreateEqual = function (target) {
  return this >= target;
}
Date.prototype.isLessThan = function (target) {
  return this < target;
}
Date.prototype.isLessEqual = function (target) {
  return this <= target;
}
